import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ACLService } from '@delon/acl';
import { TranslateService } from '@ngx-translate/core';

import Heartbeats from 'heartbeats';
import { ALAIN_I18N_TOKEN, MenuService, SettingsService, TitleService, User } from '@delon/theme';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { NzIconService } from 'ng-zorro-antd/icon';
import { Observable, zip } from 'rxjs';
import { catchError, map, window } from 'rxjs/operators';
import { IdentityService } from '@shared/itcore/services/identity.service';

import { ICONS } from '../../../style-icons';
import { ICONS_AUTO } from '../../../style-icons-auto';
import { I18NService } from '../i18n/i18n.service';
const loaction = location
/**
 * Used for application startup
 * Generally used to get the basic data of the application, like: Menu Data, User Data, etc.
 */
@Injectable()
export class StartupService {
  constructor(
    iconSrv: NzIconService,
    private injector: Injector,
    private menuService: MenuService,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    private settingService: SettingsService,
    private aclService: ACLService,
    private titleService: TitleService,
    private httpClient: HttpClient,
    private router: Router,
    private translate: TranslateService,
  ) {
    iconSrv.addIcon(...ICONS_AUTO, ...ICONS);
  }

  private get identity(): IdentityService {
    return this.injector.get(IdentityService);
  }

  // load(): Promise<any> {
  //   // const defaultLang = this.i18n.defaultLang;
  //   // return zip(this.i18n.loadLangData(defaultLang), this.httpClient.get('assets/tmp/app-data.json')).pipe(
  //   //   // 接收其他拦截器后产生的异常消息
  //   //   catchError(res => {
  //   //     console.warn(`StartupService.load: Network request failed`, res);
  //   //     setTimeout(() => this.router.navigateByUrl(`/exception/500`));
  //   //     return [];
  //   //   }),
  //   //   map(([langData, appData]: [Record<string, string>, NzSafeAny]) => {
  //   //     // setting language data
  //   //     this.i18n.use(defaultLang, langData);

  //   //     // 应用信息：包括站点名、描述、年份
  //   //     this.settingService.setApp(appData.app);
  //   //     // 用户信息：包括姓名、头像、邮箱地址
  //   //     this.settingService.setUser(appData.user);
  //   //     // ACL：设置权限为全量
  //   //     this.aclService.setFull(true);
  //   //     // 初始化菜单
  //   //     this.menuService.add(appData.menu);
  //   //     // 设置页面标题的后缀
  //   //     this.titleService.default = '';
  //   //     this.titleService.suffix = appData.app.name;
  //   //   })
  //   // );
  //   return new Promise((resolve, reject) => {
  //     this.viaHttp(resolve, reject);
  //     this.viaHeartbeats();
  //   });

  // }

  load(): Observable<void> {
    const defaultLang = this.i18n.defaultLang;
    return zip
      (
        this.i18n.loadLangData(defaultLang),
        this.httpClient.get('assets/tmp/app-data.json'),
        this.httpClient.get('api/security/getauthinfo'), // 获取当前用户的权限点string[]
        this.httpClient.get('api/identity/profile')// 获取用户信息
      ).pipe(
        // 接收其他拦截器后产生的异常消息
        catchError(res => {
          console.warn(`StartupService.load: Network request failed`, res);
          setTimeout(() => this.router.navigateByUrl(`/exception/500`));
          return [];
        }),
        map(([langData, appData, authInfo, userInfo]: [Record<string, string>, NzSafeAny, any, any]) => {
          // setting language data
          this.i18n.use(defaultLang, langData);

          // 应用信息：包括站点名、描述、年份
          this.settingService.setApp(appData.app);
          // 用户信息：包括姓名、头像、邮箱地址
          if (userInfo && userInfo.UserName) {
            const user: User = {
              name: userInfo.UserName,
              avatar: userInfo.HeadImg,
              email: userInfo.Email,
              nickName: userInfo.NickName
            };
            this.settingService.setUser(user);
          }

          // ACL：设置权限为全量
          this.aclService.setFull(true);
          //设置用户权限
          this.aclService.setAbility(authInfo);
          // 初始化菜单
          this.menuService.add(appData.menu);
          //loaction.reload()
          // 设置页面标题的后缀
          this.titleService.default = '';
          this.titleService.suffix = appData.app.name;
        })
      );

  }

  load2(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.viaHttp(resolve, reject);
      this.viaHeartbeats();
    });
  }

  // 心跳业务
  private viaHeartbeats() {
    const heart = Heartbeats.createHeart(1000);
    // 每5秒检测AccessToken有效期，如过期则使用RefreshToken来刷新
    heart.createEvent(5, () => {
      if (!this.identity) {
        return;
      }
      this.identity.tryRefreshToken();
    });
  }

  private viaHttp(resolve: any, reject: any) {
    const defaultLang = this.i18n.defaultLang;
    zip(
      this.i18n.loadLangData(defaultLang),
      this.httpClient.get('assets/tmp/app-data.json'),
      this.httpClient.get('api/security/getauthinfo'), // 获取当前用户的权限点string[]
      this.httpClient.get('api/identity/profile'), // 获取用户信息
    )
      .pipe(
        catchError(([langData, appData, authInfo, userInfo]) => {
          resolve(null);
          return [langData, appData, authInfo, userInfo];
        }),
      )
      .subscribe(
        ([langData, appData, authInfo, userInfo]) => {

          const res: any = appData;
          this.settingService.setApp(res.app);
          if (userInfo && userInfo.UserName) {
            const user: User = {
              name: userInfo.UserName,
              avatar: userInfo.HeadImg,
              email: userInfo.Email,
              nickName: userInfo.NickName
            };
            this.settingService.setUser(user);//用户信息：包括姓名、头像、邮箱地址
          }

          this.aclService.setAbility(authInfo);

          this.titleService.suffix = res.app.name;

          // 
          this.i18n.use(defaultLang, langData);

          // ACL：设置权限为全量
          this.aclService.setFull(true);
          // 初始化菜单
          this.menuService.add(appData.menu);
          // 设置页面标题的后缀
          this.titleService.default = '';
        },
        () => {
        },
        () => {
          resolve(null);
        },
      );
  }
}
